<template>
  <div>
    <DynamicComponent edc-id="polaris-partner" framework="Vue" :edc-dev="edcDev" />
  </div>
</template>

<script>
export default {
  name: 'PolarisPartner',
  data() {
    return {
      edcDev: window.__EDC__.options.dev,
    }
  },
}
</script>
